import styled from "@emotion/styled";
import React from "react";
import { CaregiverComplianceItemMobile } from "../../../messages";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { getComplianceCardInfo } from "../../../utils/complianceUtils";
import ScaffoldTitle from "../../Scaffold/components/ScaffoldTitle";
import Scaffold from "../../Scaffold/Scaffold";
import ComplianceItemCard from "./ComplianceItemCard";
import EmptyBox from "./EmptyBox";

type Props =
  | {
      isLoading: true;
      onClickGoBack: () => void;
    }
  | {
      isLoading: false;
      items: CaregiverComplianceItemMobile[];
      onClickComplianceItem: (item: CaregiverComplianceItemMobile) => void;
      onClickGoBack: () => void;
    };

function CompliantItemsScreen(props: Props) {
  const scaffoldTitle = <ScaffoldTitle label={translate(STRINGS.COMPLIANCE)} />;

  if (props.isLoading) {
    return <ScreenLoading {...props} scaffoldTitle={scaffoldTitle} />;
  }

  return <ScreenLoaded {...props} scaffoldTitle={scaffoldTitle} />;
}

function ScreenLoaded(props: Props & { isLoading: false; scaffoldTitle: React.ReactNode }) {
  const items = props.items.map(getComplianceCardInfo).filter((item) => item.type === "compliant");

  return (
    <Scaffold title={props.scaffoldTitle} onClickGoBack={props.onClickGoBack}>
      <CompliantItemsScreen.Body>
        <CompliantItemsScreen.Section>
          {items.length === 0 && (
            <EmptyBox
              title={translate(STRINGS.NO_COMPLIANT_ITEMS)}
              message={translate(STRINGS.SUBMIT_YOUR_DOCUMENTS_TO_GET_COMPLIANT)}
            />
          )}
          {items.map((data) => (
            <ComplianceItemCard
              key={data.item.documentType.id.toString()}
              {...data}
              isLoading={false}
              onClick={() => props.onClickComplianceItem(data.item)}
            />
          ))}
        </CompliantItemsScreen.Section>
      </CompliantItemsScreen.Body>
    </Scaffold>
  );
}

function ScreenLoading(props: Props & { scaffoldTitle: React.ReactNode }) {
  return (
    <Scaffold title={props.scaffoldTitle} onClickGoBack={props.onClickGoBack}>
      <CompliantItemsScreen.Body>
        <CompliantItemsScreen.Section>
          {[...Array(12)].map((_, key) => (
            <ComplianceItemCard key={key} isLoading={true} />
          ))}
        </CompliantItemsScreen.Section>
      </CompliantItemsScreen.Body>
    </Scaffold>
  );
}

CompliantItemsScreen.Body = styled.div`
  margin: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

CompliantItemsScreen.Section = styled.div`
  display: flex;
  margin-top: 12px;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
`;

export default CompliantItemsScreen;
